// Translations for Dion Hair Clinic
// All UI text in German and English

const translations = {
  // ==========================================
  // NAVIGATION & HEADER
  // ==========================================
  nav: {
    results: { de: 'Ergebnisse', en: 'Results' },
    whyUs: { de: 'Warum wir', en: 'Why Us' },
    process: { de: 'Ablauf', en: 'Process' },
    prices: { de: 'Preise', en: 'Prices' },
    team: { de: 'Team', en: 'Team' },
    contact: { de: 'Kontakt', en: 'Contact' },
    bookConsultation: { de: 'Beratung buchen', en: 'Book Consultation' },
    freeConsultation: { de: 'Kostenlose Beratung', en: 'Free Consultation' },
    aiAnalysis: { de: 'KI-Analyse', en: 'AI Analysis' },
    freeAiAnalysis: { de: 'Kostenlose KI-Analyse', en: 'Free AI Analysis' },
    switchToLight: { de: 'Zu hellem Modus wechseln', en: 'Switch to light mode' },
    switchToDark: { de: 'Zu dunklem Modus wechseln', en: 'Switch to dark mode' },
  },

  // ==========================================
  // HERO SECTION
  // ==========================================
  hero: {
    // Main page
    title: { de: 'Natürliche Haartransplantation', en: 'Natural Hair Transplant' },
    subtitle: { de: 'in Deutschland', en: 'in Germany' },
    description: { 
      de: 'Modernste FUE- und DHI-Technologie, erfahrene Spezialisten und natürlich aussehende Ergebnisse. Dion Hair Clinic - Ihre erste Wahl für Haartransplantation.',
      en: 'State-of-the-art FUE and DHI technology, experienced specialists, and natural-looking results. Dion Hair Clinic - Your first choice for hair transplantation.'
    },
    badge: { de: 'Führende Haarklinik in Deutschland', en: 'Leading Hair Clinic in Germany' },
    
    // Beard page
    beardTitle: { de: 'Barthaartransplantation', en: 'Beard Transplant' },
    beardSubtitle: { de: 'Voller Bart, natürlich', en: 'Full Beard, Naturally' },
    beardDescription: {
      de: 'Voller, dichter Bart - dauerhaft und natürlich. Präzise Transplantation für maskuline Ergebnisse.',
      en: 'Full, dense beard - permanent and natural. Precise transplantation for masculine results.'
    },
    beardBadge: { de: 'Spezialist für Barttransplantation', en: 'Beard Transplant Specialist' },
    
    // Eyebrow page
    eyebrowTitle: { de: 'Augenbrauentransplantation', en: 'Eyebrow Transplant' },
    eyebrowSubtitle: { de: 'Natürliche Schönheit, dauerhaft', en: 'Natural Beauty, Permanent' },
    eyebrowDescription: {
      de: 'Volle, perfekt geformte Augenbrauen - die dauerhafte Alternative zu Microblading. Präzise Transplantation für natürliche Ergebnisse.',
      en: 'Full, perfectly shaped eyebrows - the permanent alternative to microblading. Precise transplantation for natural results.'
    },
    eyebrowBadge: { de: 'Spezialist für Augenbrauen', en: 'Eyebrow Specialist' },
  },

  // ==========================================
  // STATS
  // ==========================================
  stats: {
    successfulTreatments: { de: 'Erfolgreiche Behandlungen', en: 'Successful Treatments' },
    yearsExperience: { de: 'Jahre Erfahrung', en: 'Years Experience' },
    satisfiedPatients: { de: 'Zufriedene Patienten', en: 'Satisfied Patients' },
    googleRating: { de: 'Google Bewertung', en: 'Google Rating' },
  },

  // ==========================================
  // BEFORE/AFTER SECTION
  // ==========================================
  beforeAfter: {
    sectionBadge: { de: 'Echte Ergebnisse', en: 'Real Results' },
    sectionTitle: { de: 'Vorher & Nachher', en: 'Before & After' },
    sectionDescription: {
      de: 'Überzeugen Sie sich selbst von unseren Ergebnissen. Bewegen Sie den Slider, um den Unterschied zu sehen.',
      en: 'See our results for yourself. Move the slider to see the difference.'
    },
    before: { de: 'Vorher', en: 'Before' },
    after: { de: 'Nachher', en: 'After' },
    grafts: { de: 'Grafts', en: 'Grafts' },
    technique: { de: 'Technik', en: 'Technique' },
    moreExamples: { de: 'Weitere Beispiele auf WhatsApp', en: 'More examples on WhatsApp' },
    dragToCompare: { de: 'Ziehen zum Vergleichen', en: 'Drag to compare' },
    viewMoreOnWhatsApp: {
      de: 'Erhalten Sie mehr Vorher-Nachher-Bilder direkt auf WhatsApp',
      en: 'Get more before-after images directly on WhatsApp'
    },
  },

  // ==========================================
  // EXPERTISE SECTION
  // ==========================================
  expertise: {
    sectionBadge: { de: 'Unsere Expertise', en: 'Our Expertise' },
    sectionTitle: { de: 'Warum Dion Hair Clinic?', en: 'Why Dion Hair Clinic?' },
    sectionDescription: {
      de: 'Wir kombinieren modernste Technologie mit jahrelanger Erfahrung für erstklassige Ergebnisse.',
      en: 'We combine cutting-edge technology with years of experience for first-class results.'
    },
    modernTechnology: { de: 'Modernste Technologie', en: 'Modern Technology' },
    modernTechnologyDesc: {
      de: 'Wir verwenden ausschließlich die neuesten FUE- und DHI-Techniken mit Saphirklingen für minimale Narbenbildung.',
      en: 'We exclusively use the latest FUE and DHI techniques with sapphire blades for minimal scarring.'
    },
    experiencedSpecialists: { de: 'Erfahrene Spezialisten', en: 'Experienced Specialists' },
    experiencedSpecialistsDesc: {
      de: 'Unser Team besteht aus zertifizierten Haarchirurgen mit über 15 Jahren Erfahrung in der Haartransplantation.',
      en: 'Our team consists of certified hair surgeons with over 15 years of experience in hair transplantation.'
    },
    naturalResults: { de: 'Natürliche Ergebnisse', en: 'Natural Results' },
    naturalResultsDesc: {
      de: 'Wir garantieren natürlich aussehende Haarlinien, die perfekt zu Ihrer Gesichtsform passen.',
      en: 'We guarantee natural-looking hairlines that perfectly match your face shape.'
    },
    quickRecovery: { de: 'Schnelle Erholung', en: 'Quick Recovery' },
    quickRecoveryDesc: {
      de: 'Dank minimalinvasiver Techniken sind die meisten Patienten innerhalb weniger Tage wieder einsatzbereit.',
      en: 'Thanks to minimally invasive techniques, most patients are back on their feet within a few days.'
    },
    transparentPrices: { de: 'Transparente Preise', en: 'Transparent Prices' },
    transparentPricesDesc: {
      de: 'Keine versteckten Kosten. Sie erhalten ein detailliertes Angebot vor Ihrer Behandlung.',
      en: 'No hidden costs. You receive a detailed quote before your treatment.'
    },
    centralLocation: { de: 'Zentrale Lage', en: 'Central Location' },
    centralLocationDesc: {
      de: 'Unsere Klinik in Mönchengladbach ist ideal erreichbar aus Köln, Düsseldorf, dem Ruhrgebiet und den Niederlanden.',
      en: 'Our clinic in Mönchengladbach is ideally accessible from Cologne, Düsseldorf, the Ruhr area and the Netherlands.'
    },
  },

  // ==========================================
  // TECHNIQUES SECTION
  // ==========================================
  techniques: {
    sectionBadge: { de: 'Modernste Technologien', en: 'Latest Technologies' },
    sectionTitle: { de: 'Unsere Techniken', en: 'Our Techniques' },
    sectionDescription: {
      de: 'Wir nutzen die fortschrittlichsten Methoden der Haartransplantation - individuell abgestimmt auf Ihre Bedürfnisse.',
      en: 'We use the most advanced methods of hair transplantation - individually tailored to your needs.'
    },
    
    // Saphir FUE
    saphirName: { de: 'Saphir FUE', en: 'Sapphire FUE' },
    saphirSubtitle: { de: 'Goldstandard der Haartransplantation', en: 'Gold Standard in Hair Transplantation' },
    saphirDescription: {
      de: 'Die Saphir FUE-Technik verwendet Klingen aus echtem Saphir-Kristall für mikroskopisch kleine Einschnitte. Dies ermöglicht eine präzisere Platzierung der Grafts und schnellere Heilung.',
      en: 'The Sapphire FUE technique uses blades made of real sapphire crystal for microscopically small incisions. This allows for more precise graft placement and faster healing.'
    },
    saphirIdealFor: { de: 'Große Flächen & maximale Dichte', en: 'Large areas & maximum density' },
    
    // DHI
    dhiName: { de: 'DHI Methode', en: 'DHI Method' },
    dhiSubtitle: { de: 'Direkte Implantation ohne Rasur', en: 'Direct Implantation Without Shaving' },
    dhiDescription: {
      de: 'Die DHI-Methode (Direct Hair Implantation) ermöglicht eine direkte Transplantation ohne vorherige Kanalerstellung. Perfekt für Verdichtungen und wenn keine Rasur gewünscht wird.',
      en: 'The DHI method (Direct Hair Implantation) allows direct transplantation without prior channel creation. Perfect for densification and when shaving is not desired.'
    },
    dhiIdealFor: { de: 'Verdichtungen & keine Rasur', en: 'Densification & no shaving' },
    
    // Combination
    combiName: { de: 'Kombinations-Technik', en: 'Combination Technique' },
    combiSubtitle: { de: 'Das Beste aus beiden Welten', en: 'The Best of Both Worlds' },
    combiDescription: {
      de: 'Unsere Experten kombinieren Saphir FUE und DHI für optimale Ergebnisse. Die Technikwahl wird individuell auf Ihre Bedürfnisse abgestimmt.',
      en: 'Our experts combine Sapphire FUE and DHI for optimal results. The technique choice is individually tailored to your needs.'
    },
    combiIdealFor: { de: 'Individuelle Optimierung', en: 'Individual optimization' },
    
    // Features
    preciseAngleControl: { de: 'Präzise Winkelkontrolle', en: 'Precise angle control' },
    minimalScarring: { de: 'Minimale Narbenbildung', en: 'Minimal scarring' },
    fastHealing: { de: 'Schnelle Heilung', en: 'Fast healing' },
    naturalHairGrowth: { de: 'Natürlicher Haarwuchs', en: 'Natural hair growth' },
    noShaving: { de: 'Keine Rasur nötig', en: 'No shaving needed' },
    perfectForDensification: { de: 'Perfekt für Verdichtung', en: 'Perfect for densification' },
    
    // Stats
    microIncisions: { de: 'Mikro-Inzisionen', en: 'Micro-incisions' },
    growthRate: { de: 'Anwachsrate', en: 'Growth rate' },
    healingDays: { de: 'Tage Heilung', en: 'Days healing' },
    control: { de: 'Kontrolle', en: 'Control' },
    combined: { de: 'Kombiniert', en: 'Combined' },
    
    advantages: { de: 'Vorteile', en: 'Advantages' },
    disclaimer: {
      de: '* Die Anwachsrate kann je nach individuellen Faktoren variieren. Ergebnisse basieren auf klinischen Beobachtungen.',
      en: '* Growth rate may vary depending on individual factors. Results are based on clinical observations.'
    },
  },

  // ==========================================
  // PROCESS SECTION
  // ==========================================
  process: {
    sectionBadge: { de: 'Ihr Weg zum vollen Haar', en: 'Your Path to Full Hair' },
    sectionTitle: { de: 'Der Ablauf', en: 'The Process' },
    sectionDescription: {
      de: 'Von der ersten Beratung bis zum finalen Ergebnis - wir begleiten Sie auf jedem Schritt.',
      en: 'From the first consultation to the final result - we accompany you every step of the way.'
    },
    
    step1Title: { de: 'Kostenlose Beratung', en: 'Free Consultation' },
    step1Desc: {
      de: 'Vereinbaren Sie einen Termin für Ihre persönliche Haaranalyse - online oder vor Ort in unserem Standort in Mönchengladbach.',
      en: 'Schedule an appointment for your personal hair analysis - online or on-site at our location in Mönchengladbach.'
    },
    step2Title: { de: 'Detaillierte Planung', en: 'Detailed Planning' },
    step2Desc: {
      de: 'Mit KI-basierter Trichoskopie analysieren wir Ihre Haarstruktur und besprechen die optimale Anzahl der Grafts sowie die Haarlinie.',
      en: 'Using AI-based trichoscopy, we analyze your hair structure and discuss the optimal number of grafts and hairline.'
    },
    step3Title: { de: 'Die Behandlung', en: 'The Treatment' },
    step3Desc: {
      de: 'Am Behandlungstag werden Sie von unserem erfahrenen Team betreut. Die Prozedur dauert je nach Umfang 4-8 Stunden unter lokaler Betäubung.',
      en: 'On the treatment day, you will be cared for by our experienced team. The procedure takes 4-8 hours under local anesthesia depending on the scope.'
    },
    step4Title: { de: 'Nachsorge', en: 'Aftercare' },
    step4Desc: {
      de: 'Wir geben Ihnen detaillierte Pflegeanweisungen und sind für alle Ihre Fragen da. Regelmäßige Kontrolltermine sichern optimale Ergebnisse.',
      en: 'We provide detailed care instructions and are available for all your questions. Regular check-ups ensure optimal results.'
    },
    step5Title: { de: 'Das Ergebnis', en: 'The Result' },
    step5Desc: {
      de: 'Nach 12-18 Monaten sehen Sie das vollständige Ergebnis: dichtes, natürlich aussehendes Haar, das ein Leben lang hält.',
      en: 'After 12-18 months you will see the complete result: dense, natural-looking hair that lasts a lifetime.'
    },
  },

  // ==========================================
  // PRICING SECTION
  // ==========================================
  pricing: {
    sectionBadge: { de: 'Transparente Preise', en: 'Transparent Prices' },
    sectionTitle: { de: 'Unsere Pakete', en: 'Our Packages' },
    sectionDescription: {
      de: 'Faire und transparente Preise für Ihre Haartransplantation. Alle Pakete inklusive umfassender Vor- und Nachsorge.',
      en: 'Fair and transparent prices for your hair transplant. All packages include comprehensive before and after care.'
    },
    
    basic: { de: 'Basic', en: 'Basic' },
    advanced: { de: 'Advanced', en: 'Advanced' },
    premium: { de: 'Premium', en: 'Premium' },
    popular: { de: 'Beliebt', en: 'Popular' },
    
    upToGrafts: { de: 'bis {count} Grafts', en: 'up to {count} Grafts' },
    hybridUpgrade: { de: 'DHI-Upgrade', en: 'DHI Upgrade' },
    
    // Features
    fueSaphirMethod: { de: 'FUE Saphir Methode', en: 'FUE Sapphire Method' },
    localAnesthesia: { de: 'Lokale Betäubung', en: 'Local Anesthesia' },
    painFreeAnesthesia: { de: 'Schmerzfreie Betäubung', en: 'Pain-free Anesthesia' },
    aftercareKit: { de: 'Nachsorgekit (Nackenkissen, Shampoo)', en: 'Aftercare kit (neck pillow, shampoo)' },
    aftercareKitPlus: { de: 'Nachsorgekit (Nackenkissen, Shampoo, Pflegespray und Medikamente)', en: 'Aftercare kit (neck pillow, shampoo, care spray and medication)' },
    aftercareKitBasic: { de: 'Nachsorgekit (Nackenkissen, Shampoo) + Medikamentenrezept', en: 'Aftercare kit (neck pillow, shampoo) + medication prescription' },
    monthsAftercare: { de: '{count} Monate Nachbetreuung', en: '{count} months aftercare' },
    regenerativeTherapies: { de: '{count} Regenerative Haartherapie', en: '{count} Regenerative hair therapy' },
    regenerativeTherapiesPlural: { de: '{count} Regenerative Haartherapien', en: '{count} Regenerative hair therapies' },
    hotelIncluded: { de: 'Hotelübernachtung inklusive', en: 'Hotel stay included' },
    
    selectPackage: { de: 'Paket wählen', en: 'Select Package' },
    bookNow: { de: 'Jetzt buchen', en: 'Book Now' },
    startingFrom: { de: 'ab', en: 'from' },
  },

  // ==========================================
  // TEAM SECTION
  // ==========================================
  team: {
    sectionBadge: { de: 'Die Menschen hinter Ihrem Erfolg', en: 'The People Behind Your Success' },
    sectionTitle: { de: 'Unser Team', en: 'Our Team' },
    sectionDescription: {
      de: 'Lernen Sie die erfahrenen Spezialisten kennen, die sich um Ihr neues Haar kümmern.',
      en: 'Meet the experienced specialists who will take care of your new hair.'
    },
  },

  // ==========================================
  // CLINIC SECTION
  // ==========================================
  clinic: {
    sectionBadge: { de: 'Unsere Räumlichkeiten', en: 'Our Facilities' },
    sectionTitle: { de: 'Die Klinik', en: 'The Clinic' },
    sectionDescription: {
      de: 'Modernste Ausstattung in angenehmer Atmosphäre für Ihren Komfort und beste Ergebnisse.',
      en: 'State-of-the-art equipment in a pleasant atmosphere for your comfort and best results.'
    },
    
    address: { de: 'Adresse', en: 'Address' },
    openingHours: { de: 'Öffnungszeiten', en: 'Opening Hours' },
    weekdays: { de: 'Mo - Fr', en: 'Mon - Fri' },
    saturday: { de: 'Sa', en: 'Sat' },
    sunday: { de: 'So', en: 'Sun' },
    closed: { de: 'Geschlossen', en: 'Closed' },
  },

  // ==========================================
  // TESTIMONIALS SECTION
  // ==========================================
  testimonials: {
    sectionBadge: { de: 'Erfahrungen unserer Patienten', en: 'Patient Experiences' },
    sectionTitle: { de: 'Das sagen unsere Patienten', en: 'What Our Patients Say' },
    sectionDescription: {
      de: 'Echte Bewertungen von echten Patienten. Lesen Sie, warum sich so viele für uns entscheiden.',
      en: 'Real reviews from real patients. Read why so many choose us.'
    },
    verifiedPatient: { de: 'Verifizierter Patient', en: 'Verified Patient' },
  },

  // ==========================================
  // FAQ SECTION
  // ==========================================
  faq: {
    sectionBadge: { de: 'Häufige Fragen', en: 'Frequently Asked Questions' },
    sectionTitle: { de: 'FAQ', en: 'FAQ' },
    sectionDescription: {
      de: 'Antworten auf die häufigsten Fragen rund um die Haartransplantation.',
      en: 'Answers to the most common questions about hair transplantation.'
    },
    moreQuestions: { de: 'Haben Sie weitere Fragen?', en: 'Do you have more questions?' },
    contactUs: { de: 'Kontaktieren Sie uns', en: 'Contact us' },
  },

  // ==========================================
  // CONTACT SECTION
  // ==========================================
  contact: {
    sectionBadge: { de: 'Kontakt', en: 'Contact' },
    sectionTitle: { de: 'Schreiben Sie uns', en: 'Write to Us' },
    sectionDescription: {
      de: 'Haben Sie Fragen oder möchten Sie einen Termin vereinbaren? Wir sind für Sie da.',
      en: 'Do you have questions or would you like to make an appointment? We are here for you.'
    },
    
    name: { de: 'Name', en: 'Name' },
    email: { de: 'E-Mail', en: 'Email' },
    phone: { de: 'Telefon', en: 'Phone' },
    message: { de: 'Nachricht', en: 'Message' },
    submit: { de: 'Nachricht senden', en: 'Send Message' },
    sending: { de: 'Wird gesendet...', en: 'Sending...' },
    
    namePlaceholder: { de: 'Ihr vollständiger Name', en: 'Your full name' },
    emailPlaceholder: { de: 'ihre.email@beispiel.de', en: 'your.email@example.com' },
    phonePlaceholder: { de: '+49 123 456789', en: '+49 123 456789' },
    messagePlaceholder: { de: 'Wie können wir Ihnen helfen?', en: 'How can we help you?' },
    
    successTitle: { de: 'Nachricht gesendet!', en: 'Message Sent!' },
    successMessage: { de: 'Vielen Dank für Ihre Nachricht. Wir melden uns in Kürze bei Ihnen.', en: 'Thank you for your message. We will get back to you shortly.' },
    errorTitle: { de: 'Fehler', en: 'Error' },
    errorMessage: { de: 'Es gab ein Problem beim Senden Ihrer Nachricht. Bitte versuchen Sie es erneut.', en: 'There was a problem sending your message. Please try again.' },
    
    privacyNotice: {
      de: 'Mit dem Absenden stimmen Sie unserer Datenschutzerklärung zu.',
      en: 'By submitting, you agree to our privacy policy.'
    },
  },

  // ==========================================
  // FOOTER
  // ==========================================
  footer: {
    about: { de: 'Über uns', en: 'About Us' },
    aboutText: {
      de: 'Dion Hair Clinic ist Ihr Experte für Haartransplantation in Deutschland. Mit modernster Technologie und erfahrenen Spezialisten bieten wir Ihnen natürlich aussehende Ergebnisse.',
      en: 'Dion Hair Clinic is your expert for hair transplantation in Germany. With state-of-the-art technology and experienced specialists, we offer you natural-looking results.'
    },
    quickLinks: { de: 'Quicklinks', en: 'Quick Links' },
    legal: { de: 'Rechtliches', en: 'Legal' },
    imprint: { de: 'Impressum', en: 'Imprint' },
    privacy: { de: 'Datenschutz', en: 'Privacy Policy' },
    terms: { de: 'AGB', en: 'Terms & Conditions' },
    allRightsReserved: { de: 'Alle Rechte vorbehalten.', en: 'All rights reserved.' },
  },

  // ==========================================
  // MODALS
  // ==========================================
  modals: {
    // Consultation Modal
    consultationTitle: { de: 'Beratungstermin buchen', en: 'Book Consultation' },
    consultationSubtitle: {
      de: 'Wählen Sie Ihren bevorzugten Termin für eine kostenlose Beratung.',
      en: 'Choose your preferred date for a free consultation.'
    },
    
    // Hair Analysis Modal
    analysisTitle: { de: 'Kostenlose Haaranalyse', en: 'Free Hair Analysis' },
    analysisSubtitle: {
      de: 'Erhalten Sie eine KI-gestützte Analyse Ihrer Haarsituation.',
      en: 'Get an AI-powered analysis of your hair situation.'
    },
    stepOf: { de: 'Schritt {current} von {total}', en: 'Step {current} of {total}' },
    next: { de: 'Weiter', en: 'Next' },
    back: { de: 'Zurück', en: 'Back' },
    submit: { de: 'Absenden', en: 'Submit' },
    close: { de: 'Schließen', en: 'Close' },
  },

  // ==========================================
  // COOKIE BANNER
  // ==========================================
  cookies: {
    title: { de: 'Wir respektieren Ihre Privatsphäre', en: 'We Respect Your Privacy' },
    description: {
      de: 'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern und unsere Website zu optimieren. Mit Ihrer Zustimmung nutzen wir Google Analytics zur Analyse des Nutzerverhaltens.',
      en: 'We use cookies to improve your experience and optimize our website. With your consent, we use Google Analytics to analyze user behavior.'
    },
    acceptAll: { de: 'Alle akzeptieren', en: 'Accept All' },
    acceptNecessary: { de: 'Nur notwendige', en: 'Necessary Only' },
    showDetails: { de: 'Details anzeigen', en: 'Show Details' },
    privacyPolicy: { de: 'Datenschutzerklärung', en: 'Privacy Policy' },
    imprint: { de: 'Impressum', en: 'Imprint' },
  },

  // ==========================================
  // APP SECTION
  // ==========================================
  app: {
    sectionBadge: { de: 'Ihre Nachsorge digital', en: 'Your Digital Aftercare' },
    sectionTitle: { de: 'Die Dion Hair App', en: 'The Dion Hair App' },
    sectionDescription: {
      de: 'Verfolgen Sie Ihren Fortschritt, erhalten Sie Pflegetipps und bleiben Sie mit unserem Team in Kontakt.',
      en: 'Track your progress, get care tips, and stay in touch with our team.'
    },
    feature1: { de: 'Fortschrittsverfolgung', en: 'Progress Tracking' },
    feature2: { de: 'Pflegeerinnerungen', en: 'Care Reminders' },
    feature3: { de: 'Direkter Kontakt', en: 'Direct Contact' },
    downloadSoon: { de: 'Bald verfügbar', en: 'Coming Soon' },
  },

  // ==========================================
  // PATTERNS (Beard & Eyebrow)
  // ==========================================
  patterns: {
    // Beard patterns section
    beardSectionBadge: { de: 'Behandlungsoptionen', en: 'Treatment Options' },
    beardSectionTitle: { de: 'Typische Bartmuster', en: 'Typical Beard Patterns' },
    beardSectionDescription: {
      de: 'Jedes Bartmuster erfordert einen individuellen Behandlungsansatz. Hier finden Sie einen Überblick über die häufigsten Muster und die entsprechenden Behandlungsoptionen.',
      en: 'Each beard pattern requires an individual treatment approach. Here you will find an overview of the most common patterns and corresponding treatment options.'
    },
    
    // Eyebrow patterns section
    eyebrowSectionBadge: { de: 'Behandlungsoptionen', en: 'Treatment Options' },
    eyebrowSectionTitle: { de: 'Typische Augenbrauenmuster', en: 'Typical Eyebrow Patterns' },
    eyebrowSectionDescription: {
      de: 'Jedes Augenbrauenmuster erfordert einen individuellen Behandlungsansatz. Hier finden Sie einen Überblick über die häufigsten Muster und die entsprechenden Behandlungsoptionen.',
      en: 'Each eyebrow pattern requires an individual treatment approach. Here you will find an overview of the most common patterns and corresponding treatment options.'
    },
    
    typicalGrafts: { de: 'Typische Grafts', en: 'Typical Grafts' },
    treatment: { de: 'Behandlung', en: 'Treatment' },
    session: { de: 'Sitzung', en: 'Session' },
    sessions: { de: 'Sitzungen', en: 'Sessions' },
  },

  // ==========================================
  // COMMON
  // ==========================================
  common: {
    learnMore: { de: 'Mehr erfahren', en: 'Learn More' },
    getStarted: { de: 'Jetzt starten', en: 'Get Started' },
    viewAll: { de: 'Alle anzeigen', en: 'View All' },
    loading: { de: 'Lädt...', en: 'Loading...' },
    error: { de: 'Fehler', en: 'Error' },
    success: { de: 'Erfolg', en: 'Success' },
    germany: { de: 'Deutschland', en: 'Germany' },
    from: { de: 'ab', en: 'from' },
    euro: { de: '€', en: '€' },
  },

  // ==========================================
  // DYNAMIC DATA TRANSLATIONS
  // ==========================================
  data: {
    // Expertise Items
    expertise: {
      modernTechnology: { 
        title: { de: 'Modernste Technologie', en: 'Modern Technology' },
        desc: { de: 'Wir verwenden ausschließlich die neuesten FUE- und DHI-Techniken mit Saphirklingen für minimale Narbenbildung.', en: 'We exclusively use the latest FUE and DHI techniques with sapphire blades for minimal scarring.' }
      },
      experiencedSpecialists: {
        title: { de: 'Erfahrene Spezialisten', en: 'Experienced Specialists' },
        desc: { de: 'Unser Team besteht aus zertifizierten Haarchirurgen mit über 15 Jahren Erfahrung in der Haartransplantation.', en: 'Our team consists of certified hair surgeons with over 15 years of experience in hair transplantation.' }
      },
      naturalResults: {
        title: { de: 'Natürliche Ergebnisse', en: 'Natural Results' },
        desc: { de: 'Wir garantieren natürlich aussehende Haarlinien, die perfekt zu Ihrer Gesichtsform passen.', en: 'We guarantee natural-looking hairlines that perfectly match your face shape.' }
      },
      quickRecovery: {
        title: { de: 'Schnelle Erholung', en: 'Quick Recovery' },
        desc: { de: 'Dank minimalinvasiver Techniken sind die meisten Patienten innerhalb weniger Tage wieder einsatzbereit.', en: 'Thanks to minimally invasive techniques, most patients are back on their feet within a few days.' }
      },
      transparentPrices: {
        title: { de: 'Transparente Preise', en: 'Transparent Prices' },
        desc: { de: 'Keine versteckten Kosten. Sie erhalten ein detailliertes Angebot vor Ihrer Behandlung.', en: 'No hidden costs. You receive a detailed quote before your treatment.' }
      },
      centralLocation: {
        title: { de: 'Zentrale Lage', en: 'Central Location' },
        desc: { de: 'Unsere Klinik in Mönchengladbach ist ideal erreichbar aus Köln, Düsseldorf, dem Ruhrgebiet und den Niederlanden.', en: 'Our clinic in Mönchengladbach is ideally accessible from Cologne, Düsseldorf, the Ruhr area and the Netherlands.' }
      },
    },

    // Process Steps
    processSteps: {
      step1: {
        title: { de: 'Kostenlose Beratung', en: 'Free Consultation' },
        desc: { de: 'Vereinbaren Sie einen Termin für Ihre persönliche Haaranalyse - online oder vor Ort in unserem Standort in Mönchengladbach.', en: 'Schedule an appointment for your personal hair analysis - online or on-site at our location in Mönchengladbach.' }
      },
      step2: {
        title: { de: 'Detaillierte Planung', en: 'Detailed Planning' },
        desc: { de: 'Mit KI-basierter Trichoskopie analysieren wir Ihre Haarstruktur und besprechen die optimale Anzahl der Grafts sowie die Haarlinie.', en: 'Using AI-based trichoscopy, we analyze your hair structure and discuss the optimal number of grafts and hairline.' }
      },
      step3: {
        title: { de: 'Die Behandlung', en: 'The Treatment' },
        desc: { de: 'Am Behandlungstag werden Sie von unserem erfahrenen Team betreut. Die Prozedur dauert je nach Umfang 4-8 Stunden unter lokaler Betäubung.', en: 'On treatment day, you will be cared for by our experienced team. The procedure takes 4-8 hours under local anesthesia depending on scope.' }
      },
      step4: {
        title: { de: 'Nachsorge', en: 'Aftercare' },
        desc: { de: 'Wir geben Ihnen detaillierte Pflegeanweisungen und sind für alle Ihre Fragen da. Regelmäßige Kontrolltermine sichern optimale Ergebnisse.', en: 'We provide detailed care instructions and are available for all your questions. Regular check-ups ensure optimal results.' }
      },
      step5: {
        title: { de: 'Das Ergebnis', en: 'The Result' },
        desc: { de: 'Nach 12-18 Monaten sehen Sie das vollständige Ergebnis: dichtes, natürlich aussehendes Haar, das ein Leben lang hält.', en: 'After 12-18 months you will see the complete result: dense, natural-looking hair that lasts a lifetime.' }
      },
    },

    // Pricing Features
    pricingFeatures: {
      fueSaphirMethod: { de: 'FUE Saphir Methode', en: 'FUE Sapphire Method' },
      localAnesthesia: { de: 'Lokale Betäubung', en: 'Local Anesthesia' },
      painFreeAnesthesia: { de: 'Schmerzfreie Betäubung', en: 'Pain-free Anesthesia' },
      aftercareKitBasic: { de: 'Nachsorgekit (Nackenkissen, Shampoo) + Medikamentenrezept', en: 'Aftercare kit (neck pillow, shampoo) + medication prescription' },
      aftercareKitAdvanced: { de: 'Nachsorgekit (Nackenkissen, Shampoo, Pflegespray und Medikamente)', en: 'Aftercare kit (neck pillow, shampoo, care spray and medication)' },
      monthsAftercare6: { de: '6 Monate Nachbetreuung', en: '6 months aftercare' },
      monthsAftercare12: { de: '12 Monate Nachbetreuung', en: '12 months aftercare' },
      monthsAftercare18: { de: '18 Monate Nachbetreuung', en: '18 months aftercare' },
      regenerativeTherapy1: { de: '1 Regenerative Haartherapie', en: '1 Regenerative hair therapy' },
      regenerativeTherapy3: { de: '3 Regenerative Haartherapien', en: '3 Regenerative hair therapies' },
      regenerativeTherapy5: { de: '5 Regenerative Haartherapien', en: '5 Regenerative hair therapies' },
      hotelIncluded: { de: 'Hotelübernachtung inklusive', en: 'Hotel overnight stay included' },
      upTo2000Grafts: { de: 'bis 2.000 Grafts', en: 'up to 2,000 Grafts' },
      upTo4500Grafts: { de: 'bis 4.500 Grafts', en: 'up to 4,500 Grafts' },
    },

    // Team Members
    team: {
      member1: {
        role: { de: 'Facharzt für Thoraxchirurgie & Haartransplantationschirurg', en: 'Thoracic Surgery Specialist & Hair Transplant Surgeon' },
        desc: { de: 'Dr. Tsomkopoulos ist Facharzt für Thoraxchirurgie mit Approbation in Deutschland und der Schweiz. Er verfügt über langjährige Erfahrung als leitender Haartransplantationschirurg in renommierten Kliniken in Berlin, Basel und Thessaloniki.', en: 'Dr. Tsomkopoulos is a specialist in thoracic surgery licensed in Germany and Switzerland. He has many years of experience as a leading hair transplant surgeon in renowned clinics in Berlin, Basel and Thessaloniki.' },
        spec: { de: 'ISHRS-Mitglied, FUE & DHI Spezialist, Approbation DE/CH', en: 'ISHRS Member, FUE & DHI Specialist, Licensed DE/CH' }
      },
      member2: {
        role: { de: 'Fachärztin für Innere Medizin und Expertin für Haartransplantationen', en: 'Internal Medicine Specialist and Hair Transplant Expert' },
        desc: { de: 'Mit ihrer umfassenden medizinischen Expertise und spezialisiertem Wissen im Bereich Haartransplantationen sorgt Dr. Bevapi für höchste medizinische Standards und optimale Behandlungsergebnisse.', en: 'With her comprehensive medical expertise and specialized knowledge in hair transplantation, Dr. Bevapi ensures the highest medical standards and optimal treatment results.' },
        spec: { de: 'Fachärztin für Innere Medizin, Spezialisierung auf Haartransplantationstechniken', en: 'Internal Medicine Specialist, Specialization in hair transplant techniques' }
      },
      member3: {
        role: { de: 'Medizinische Haartechnikerin', en: 'Medical Hair Technician' },
        desc: { de: 'Dilek Ergüney bringt umfangreiche Erfahrung in der präzisen Durchführung von Haartransplantationstechniken mit und ist spezialisiert auf die sorgfältige Handhabung von Haarfollikeln für optimale Ergebnisse.', en: 'Dilek Ergüney brings extensive experience in the precise execution of hair transplant techniques and specializes in the careful handling of hair follicles for optimal results.' },
        spec: { de: 'Zertifizierte medizinische Haartechnikerin mit Spezialisierung auf FUE- und DHI-Techniken', en: 'Certified medical hair technician specializing in FUE and DHI techniques' }
      },
      member4: {
        role: { de: 'Spezialistin für Haartransplantationen', en: 'Hair Transplant Specialist' },
        desc: { de: 'Songül Bulut absolvierte ihr Medizinstudium in der Türkei und sammelte jahrelange Erfahrung in führenden Haarkliniken weltweit. Ihre internationale Expertise garantiert erstklassige Behandlungsergebnisse.', en: 'Songül Bulut completed her medical studies in Turkey and gained years of experience in leading hair clinics worldwide. Her international expertise guarantees first-class treatment results.' },
        spec: { de: 'Medizinstudium in der Türkei, internationale Erfahrung in führenden Haarkliniken', en: 'Medical studies in Turkey, international experience in leading hair clinics' }
      },
    },

    // Testimonials
    testimonials: {
      test1: { de: 'Nach jahrelangem Haarverlust habe ich endlich den Schritt gewagt. Das Ergebnis übertrifft alle meine Erwartungen! Das Team war unglaublich professionell und einfühlsam.', en: 'After years of hair loss, I finally took the plunge. The result exceeds all my expectations! The team was incredibly professional and empathetic.' },
      test2: { de: 'Von der ersten Beratung bis zur Nachsorge - alles war perfekt organisiert. Mein Selbstbewusstsein ist zurück!', en: 'From the first consultation to aftercare - everything was perfectly organized. My confidence is back!' },
      test3: { de: 'Ich war anfangs skeptisch, aber die Ergebnisse sprechen für sich. Die Haarlinie sieht absolut natürlich aus. Vielen Dank an das gesamte Team!', en: 'I was skeptical at first, but the results speak for themselves. The hairline looks absolutely natural. Thank you to the entire team!' },
    },

    // FAQ Items
    faq: {
      q1: { 
        question: { de: 'Wie lange dauert eine Haartransplantation?', en: 'How long does a hair transplant take?' },
        answer: { de: 'Je nach Anzahl der zu transplantierenden Grafts dauert der Eingriff zwischen 4 und 8 Stunden. Sie können während der Behandlung Musik hören, Filme schauen oder sich entspannen.', en: 'Depending on the number of grafts to be transplanted, the procedure takes between 4 and 8 hours. You can listen to music, watch movies or relax during the treatment.' }
      },
      q2: {
        question: { de: 'Ist die Behandlung schmerzhaft?', en: 'Is the treatment painful?' },
        answer: { de: 'Nein, die Behandlung erfolgt unter lokaler Betäubung und ist praktisch schmerzfrei. Nur die initiale Betäubung kann als leichtes Piksen empfunden werden.', en: 'No, the treatment is performed under local anesthesia and is virtually painless. Only the initial anesthesia may be felt as a slight prick.' }
      },
      q3: {
        question: { de: 'Wann sehe ich die ersten Ergebnisse?', en: 'When will I see the first results?' },
        answer: { de: 'Die transplantierten Haare fallen zunächst aus (Shock Loss), was normal ist. Nach 3-4 Monaten beginnt das neue Wachstum, das volle Ergebnis sehen Sie nach 12-18 Monaten.', en: 'The transplanted hair initially falls out (Shock Loss), which is normal. After 3-4 months the new growth begins, you will see the full result after 12-18 months.' }
      },
      q4: {
        question: { de: 'Wie hoch ist die Anwachsrate?', en: 'What is the growth rate?' },
        answer: { de: 'Bei unseren Behandlungen liegt die Anwachsrate bei über 95%. Durch unsere langjährige Erfahrung und modernste Techniken erzielen wir hervorragende Ergebnisse.', en: 'Our treatments have a growth rate of over 95%. Thanks to our years of experience and state-of-the-art techniques, we achieve excellent results.' }
      },
      q5: {
        question: { de: 'An welchem Standort kann ich mich behandeln lassen?', en: 'At which location can I receive treatment?' },
        answer: { de: 'Unsere Klinik befindet sich in Mönchengladbach und ist ideal erreichbar aus Köln, Düsseldorf, dem Ruhrgebiet und den Niederlanden.', en: 'Our clinic is located in Mönchengladbach and is easily accessible from Cologne, Düsseldorf, the Ruhr area and the Netherlands.' }
      },
      q6: {
        question: { de: 'Sind die Ergebnisse dauerhaft?', en: 'Are the results permanent?' },
        answer: { de: 'Ja! Die transplantierten Haare stammen aus dem Spenderbereich am Hinterkopf, der genetisch resistent gegen Haarausfall ist. Diese Haare wachsen ein Leben lang.', en: 'Yes! The transplanted hair comes from the donor area at the back of the head, which is genetically resistant to hair loss. This hair grows for a lifetime.' }
      },
    },

    // Clinic Images
    clinicImages: {
      entrance: { de: 'Unsere Klinik', en: 'Our Clinic' },
      hallway: { de: 'Moderner Flur', en: 'Modern Hallway' },
      opRoom: { de: 'Steriler OP-Raum', en: 'Sterile Operating Room' },
      waitingArea: { de: 'Eleganter Wartebereich', en: 'Elegant Waiting Area' },
    },

    // Opening Hours
    openingHours: {
      weekdays: { de: 'Mo - Fr: 9:00 - 18:00 Uhr', en: 'Mon - Fri: 9:00 AM - 6:00 PM' },
      saturday: { de: 'Sa: 10:00 - 14:00 Uhr', en: 'Sat: 10:00 AM - 2:00 PM' },
      sunday: { de: 'So: Geschlossen', en: 'Sun: Closed' },
    },
  },
};

// Helper function to get translation
export const getTranslation = (key, language = 'de') => {
  const keys = key.split('.');
  let value = translations;
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
  }
  
  if (value && typeof value === 'object' && language in value) {
    return value[language];
  }
  
  return key;
};

// Hook for use with LanguageContext
export const useTranslation = (language) => {
  const t = (key, replacements = {}) => {
    let text = getTranslation(key, language);
    
    // Replace placeholders like {count} with actual values
    Object.entries(replacements).forEach(([placeholder, value]) => {
      text = text.replace(new RegExp(`\\{${placeholder}\\}`, 'g'), value);
    });
    
    return text;
  };
  
  return { t };
};

export default translations;
